import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    Layout, Breadcrumb, Row, Col, Form, Input, Select, Radio, Upload, message, Button, ConfigProvider, DatePicker, Spin,
} from 'antd';
import { HomeOutlined, LoadingOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons';
import moment from 'moment';
import CONSTANT from '../../config/constant';
import { axiosInstance } from '../../config/api';
import * as COMMON from '../../config/common';
import locale from 'antd/es/date-picker/locale/vi_VN';
const status = [
    { value: 'approve', label: 'Cần kiểm duyệt' },
    { value: 'draft', label: 'Bản nháp' },
];
const { TextArea } = Input;

const InfoAgency = () => {
    let currentUser = localStorage.getItem(CONSTANT.STORAGE_KEY_USER);
    if (currentUser) currentUser = JSON.parse(currentUser);
    const [form] = Form.useForm();
    const [idAgency, setIdAgency] = useState();
    const [loading, setLoading] = useState(false);
    const [validateStatusAgencyName, setValidateStatusAgencyName] = useState();
    const [slug, setSlug] = useState();
    const [dataAgency, setDataAgency] = useState({});

    const [logo, setLogo] = useState();
    const [type, setType] = useState(true);
    const [bussinessCerFront, setBussinessCerFront] = useState();
    const [bussinessCerBackside, setBussinessCerBackside] = useState();
    const [bussinessIssueDate, setBussinessIssueDate] = useState();
    const [identityCardFront, setIdentityCardFront] = useState();
    const [identityCardBackside, setIdentityCardBackside] = useState();
    const [identityCardIssueDate, setIdentityCardIssueDate] = useState();
    const onTypeChange = e => {
        setType(e.target.value);
    };
    const beforeUploadAvatar = type => file => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('Bạn chỉ được tải ảnh JPG/PNG!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Hình ảnh phải nhỏ hơn 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }
    const changeUploadAvatar = type => async info => {
        if (info.file.status === 'uploading') {
            return;
        }
        if (info.file.status === 'done') {
            let avatarName = '';
            const { response } = info.file;
            if (response && response.code === 200) {
                avatarName = response.data.filename;
            }
            if (type === "logo")
                setLogo(avatarName);
            else if (type === "fCard")
                setIdentityCardFront(avatarName);
            else if (type === "bCard")
                setIdentityCardBackside(avatarName);
            else if (type === "fBussiness")
                setBussinessCerFront(avatarName);
            else if (type === "bBussiness")
                setBussinessCerBackside(avatarName);
        }
    }
    // submit
    const onFinish = async (values) => {
        //debugger;
        values.logo = logo;
        values.type = type;
        values.bussiness_cer_front = bussinessCerFront;
        values.bussiness_cer_backside = bussinessCerBackside;
        values.bussiness_issue_date = bussinessIssueDate;
        values.identity_card_front = identityCardFront;
        values.identity_card_backside = identityCardBackside;
        values.identity_card_issue_date = identityCardIssueDate;
        // nếu chưa có tạo agency thì tạo mới agency
        if (!idAgency) {
            values.slug = slug;
            values.created_by = currentUser._id;
            await axiosInstance.post(`${CONSTANT.API.AGENCY_SERVICE.AGENCY}`, values)
                .then(res => {

                    if (res && res.data && res.data.code === 200) {
                        message.success('Cập nhật thông tin đăng ký thành công!', 2).then(() => window.location.reload());
                    }
                    else {
                        message.error('Cập nhật thông tin đăng ký thất bại! Vui lòng thử lại sau.');
                    }
                });
        }
        else {
            await axiosInstance.patch(`${CONSTANT.API.AGENCY_SERVICE.AGENCY}/${idAgency}`, values)
                .then(res => {

                    if (res && res.data && res.data.code === 200) {
                        message.success('Cập nhật thông tin đăng ký thành công!')
                    }
                    else {
                        message.error('Cập nhật thông tin đăng ký thất bại! Vui lòng thử lại sau.');
                    }
                });
        }

    };
    const onChange = type => (date) => {
        if (type === 'identity')
            setIdentityCardIssueDate(date);
        else if (type === 'bussiness')
            setBussinessIssueDate(date);
    }

    // effect
    useEffect(() => {
        loadAgency();
    }, []);

    // load Agency    
    const loadAgency = async () => {
        setLoading(true);
        await axiosInstance.get(`${CONSTANT.API.AGENCY_SERVICE.AGENCY}?created_by=${currentUser._id}`)
            .then(async res => {
                if (res && res.data && res.data.code === 200 && res.data.data.docs.length > 0) {
                    const data = res.data.data.docs[0];
                    setDataAgency(data);
                    setIdAgency(data._id);
                    setLogo(data.logo);
                    setType(data.type);
                    setBussinessCerFront(data.bussiness_cer_front);
                    setBussinessCerBackside(data.bussiness_cer_backside);
                    setBussinessIssueDate(moment(data.bussiness_issue_date));
                    setIdentityCardFront(data.identity_card_front);
                    setIdentityCardBackside(data.identity_card_backside);
                    setIdentityCardIssueDate(moment(data.identity_card_issue_date));
                    form.setFieldsValue({
                        name: data.name,
                        logo: data.logo,
                        content: data.content,
                        slug: data.slug,
                        owner_name: data.owner_name,
                        type: data.type,
                        //email: data.email,
                        //phone: data.phone,
                        address: data.address,
                        bussiness_code: data.bussiness_code,
                        bussiness_tax_code: data.bussiness_tax_code,
                        bussiness_issue_by: data.bussiness_issue_by,
                        identity_card_code: data.identity_card_code,
                        identity_card_issue_by: data.identity_card_issue_by,
                        bank_name: data.bank_name,
                        bank_branch_name: data.bank_branch_name,
                        account_number: data.account_number,
                        account_full_name: data.account_full_name,
                        account_full_name_upper: data.account_full_name_upper,
                        summary: data.summary,
                        status: "publish"
                        //status: data.status && data.status === "publish" ? "approve" : data.status
                    });

                }
                else {
                    message.warning('Thông tin đăng ký của bạn chưa được tạo. Hãy tạo thông tin cho dịch vụ của bạn', 5)
                }
            }).catch(error => message.warning('Không truy cập được thông tin, vui lòng quay lại sau, cảm ơn!' + error.message, 5));
        setLoading(false);
        form.setFieldsValue({
            email: currentUser.email,
            phone: `${currentUser.dial_code && `+${currentUser.dial_code}`}${currentUser?.phone ? currentUser?.phone : ''}`
        })
    }
    // Check tên đăng ký
    const validationName = async (_, value) => {
        if (idAgency) {
            if (value !== dataAgency.name) {
                let slug = COMMON.url_slug(value);
                if (slug !== '') {
                    setValidateStatusAgencyName('validating');
                    await axiosInstance.post(`${CONSTANT.API.AGENCY_SERVICE.SLUG_AGENCY_CHECK}`, { slug: slug })
                        .then(res => {
                            if (res?.data?.code === 200) {
                                if (res.data.data.exist) {
                                    setValidateStatusAgencyName('error');
                                    return Promise.reject(new Error('Tên đăng ký không khả dụng'));
                                }
                                else {
                                    setValidateStatusAgencyName('success');
                                    setSlug(slug);
                                    return Promise.resolve();
                                }
                            }
                        })
                }
            }
            else {
                return Promise.resolve();
            }
        }
        else {
            let slug = COMMON.url_slug(value);
            if (slug !== '') {
                setValidateStatusAgencyName('validating');
                await axiosInstance.post(`${CONSTANT.API.AGENCY_SERVICE.SLUG_AGENCY_CHECK}`, { slug: slug })
                    .then(res => {
                        if (res?.data?.code === 200) {
                            if (res.data.data.exist) {
                                setValidateStatusAgencyName('error');
                                return Promise.reject(new Error('Tên đăng ký không khả dụng'));
                            }
                            else {
                                setValidateStatusAgencyName('success');
                                setSlug(slug);
                                return Promise.resolve();
                            }
                        }
                    })
            }
        }

    }
    return (
        <div>
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item >
                    <Link to="/"><HomeOutlined /></Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    Dịch vụ y tế
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    Thông tin đăng ký
                </Breadcrumb.Item>
            </Breadcrumb>
            <Layout.Content className="layout-content">
                {
                    loading &&
                    <div style={{ textAlign: 'center' }}>
                        <Spin />
                    </div>
                }

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    initialValues={{
                        _id: "",
                        name: "",
                        logo: "",
                        content: "",
                        slug: "",
                        owner_name: "",
                        type: "",
                        email: "",
                        phone: "",
                        address: "",
                        bussiness_code: "",
                        bussiness_tax_code: "",
                        bussiness_issue_date: "",
                        bussiness_cer_front: "",
                        bussiness_cer_backside: "",
                        bussiness_issue_by: "",
                        identity_card_code: "",
                        identity_card_issue_date: "",
                        identity_card_front: "",
                        identity_card_backside: "",
                        identity_card_issue_by: "",
                        bank_name: "",
                        bank_branch_name: "",
                        account_number: "",
                        account_full_name: "",
                        account_full_name_upper: "",
                        summary: "",
                        status: "publish"
                    }}>
                    <Row gutter={16}>
                        <Col xs={24} sm={24} md={12}>
                            <Form.Item
                                label="Tên đăng ký"
                                name="name"
                                required tooltip="Trường bắt buộc nhập"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập tên đăng ký!' },
                                    {
                                        type: 'string', max: 50, message: "Tên đăng ký không quá 50 ký tự"
                                    },
                                    {
                                        validator: validationName
                                    }
                                ]}
                                hasFeedback
                                validateStatus={validateStatusAgencyName}
                                validateTrigger="onBlur"
                            >
                                <Input placeholder="Nhập tên đăng ký" />
                            </Form.Item>
                            <Form.Item label="Họ tên người đại diện" name="owner_name"
                                required tooltip="Trường bắt buộc nhập"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập họ tên người đại diện!' }, {
                                        type: 'string', max: 100, message: "Họ tên người đại diện không quá 100 ký tự"
                                    }
                                ]}
                            >
                                <Input placeholder="Nhập họ tên người đại diện" />
                            </Form.Item>
                            <Form.Item label="Email" name="email"
                                rules={[
                                    {
                                        type: 'email',
                                        message: 'Email không đúng định dạng',
                                    }, {
                                        type: 'string', max: 100, message: "Email không hợp lệ, tối đa 100 ký tự !"
                                    }
                                ]}
                            >
                                <Input placeholder="Nhập email" disabled />
                            </Form.Item>
                            <Form.Item label="Điện thoại" name="phone"
                                rules={[
                                    {
                                        type: 'string', max: 13, message: "Số điện thoại không đúng !"
                                    }
                                ]}>
                                <Input placeholder="Nhập số điện thoại" />
                            </Form.Item>
                            <Form.Item label="Địa chỉ" name="address"
                                rules={[
                                    {
                                        type: 'string', max: 200, message: "Địa chỉ tối đa 200 ký tự !"
                                    }
                                ]}>
                                <Input placeholder="Nhập địa chỉ" />
                            </Form.Item>
                            {/* Begin Images */}
                            <Form.Item label="Logo đại lý">
                                <Upload
                                    name="file"
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    showUploadList={false}
                                    action={`${CONSTANT.API.EXTRA.UPLOAD_AVATAR}`}
                                    data={{ type: 'agency' }}
                                    beforeUpload={beforeUploadAvatar("logo")}
                                    onChange={changeUploadAvatar("logo")}
                                    headers={{
                                        'X-TK': CONSTANT.API.KEY
                                    }}

                                >
                                    {logo ? <img src={CONSTANT.STATIC_URL + logo} style={{ width: '100%', height: '100%' }} /> :
                                        <div>
                                            {logo ? <LoadingOutlined /> : <PlusOutlined />}
                                            <div style={{ marginTop: 8 }}>Chọn logo</div>
                                        </div>}
                                </Upload>
                            </Form.Item>
                            {/* End Images */}
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                            <Form.Item label="Loại dịch vụ">
                                <Radio.Group value={type} onChange={onTypeChange}>
                                    <Radio value={true}>Tổ chức</Radio>
                                    <Radio value={false}>Cá nhân</Radio>
                                </Radio.Group>
                            </Form.Item>
                            {
                                type ? <>
                                    <Form.Item label="Mã số đăng ký kinh doanh" name="bussiness_code"
                                        rules={[
                                            {
                                                type: 'string', max: 30, message: "Mã số đăng ký kinh doanh tối đa 30 ký tự !"
                                            }
                                        ]}>
                                        <Input placeholder="Nhập Mã số đăng ký kinh doanh" />
                                    </Form.Item>
                                    <Form.Item label="Mã số thuế" name="bussiness_tax_code"
                                        rules={[
                                            {
                                                type: 'string', max: 30, message: "Mã số thuế tối đa 30 ký tự !"
                                            }
                                        ]}>
                                        <Input placeholder="Nhập mã số thuế" />
                                    </Form.Item>
                                    <Form.Item label="Ngày cấp">
                                        <ConfigProvider locale={locale}>
                                            <DatePicker
                                                className="ant-picker-input"
                                                format="DD/MM/YYYY"
                                                defaultValue={moment()}
                                                value={bussinessIssueDate}
                                                onChange={onChange('bussiness')} />
                                        </ConfigProvider>
                                    </Form.Item>
                                    <Form.Item label="Nơi cấp giấy phép đăng ký kinh doanh" name="bussiness_issue_by"
                                        rules={[
                                            {
                                                type: 'string', max: 150, message: "Nơi cấp giấy phép đăng ký kinh doanh tối đa 150 ký tự !"
                                            }
                                        ]}>
                                        <Input placeholder="Nhập nơi cấp giấy phép đăng ký kinh doanh" />
                                    </Form.Item>
                                    <Form.Item label="Ảnh giấy phép đăng ký kinh doanh">
                                        <Row>
                                            <Col>
                                                <Upload
                                                    name="file"
                                                    listType="picture-card"
                                                    className="avatar-uploader"
                                                    style={{ width: 'auto !important' }}
                                                    showUploadList={false}
                                                    action={`${CONSTANT.API.EXTRA.UPLOAD_AVATAR}`}
                                                    data={{ type: 'agency' }}
                                                    beforeUpload={beforeUploadAvatar("fBussiness")}
                                                    onChange={changeUploadAvatar("fBussiness")}
                                                    headers={{
                                                        'X-TK': CONSTANT.API.KEY
                                                    }}

                                                >
                                                    {bussinessCerFront ? <img src={CONSTANT.STATIC_URL + bussinessCerFront} alt="Mặt trước" style={{ width: '100%' }} /> :
                                                        <div>
                                                            {bussinessCerFront ? <LoadingOutlined /> : <PlusOutlined />}
                                                            <div style={{ marginTop: 8 }}>Mặt trước</div>
                                                        </div>}
                                                </Upload>

                                            </Col>
                                            <Col>
                                                <Upload
                                                    name="file"
                                                    listType="picture-card"
                                                    className="avatar-uploader"
                                                    showUploadList={false}
                                                    action={`${CONSTANT.API.EXTRA.UPLOAD_AVATAR}`}
                                                    data={{ type: 'agency' }}
                                                    beforeUpload={beforeUploadAvatar("bBussiness")}
                                                    onChange={changeUploadAvatar("bBussiness")}
                                                    headers={{
                                                        'X-TK': CONSTANT.API.KEY
                                                    }}

                                                >
                                                    {bussinessCerBackside ? <img src={CONSTANT.STATIC_URL + bussinessCerBackside} alt="Mặt sau" style={{ width: '100%' }} /> :
                                                        <div>
                                                            {bussinessCerBackside ? <LoadingOutlined /> : <PlusOutlined />}
                                                            <div style={{ marginTop: 8 }}>Mặt sau</div>
                                                        </div>}
                                                </Upload>

                                            </Col>
                                        </Row>
                                    </Form.Item></> : <>
                                    <Form.Item label="Chứng minh nhân dân/cccd/passport" name="identity_card_code"
                                        rules={[
                                            {
                                                type: 'string', max: 50, message: "Cmnd/cccd/passport tối đa 150 ký tự !"
                                            }
                                        ]}>
                                        <Input placeholder="Nhập mã cmnd/cccd/passport" />
                                    </Form.Item>
                                    <Form.Item label="Ngày cấp">
                                        <ConfigProvider locale={locale}>
                                            <DatePicker
                                                className="ant-picker-input"
                                                format="DD/MM/YYYY"
                                                defaultValue={moment()}
                                                onChange={onChange('identity')}
                                                value={identityCardIssueDate} />
                                        </ConfigProvider>
                                    </Form.Item>
                                    <Form.Item label="Nơi cấp" name="identity_card_issue_by"
                                        rules={[
                                            {
                                                type: 'string', max: 150, message: "Nơi cấp cmnd/cccd/passport tối đa 150 ký tự !"
                                            }
                                        ]}>
                                        <Input placeholder="Nhập nơi cấp cmnd/cccd/passport" />
                                    </Form.Item>
                                    <Form.Item label="Ảnh chứng minh nhân dân/cccd/passport" layout="inline">
                                        <Row>
                                            <Col>
                                                <Upload
                                                    name="file"
                                                    listType="picture-card"
                                                    style={{ width: 'auto !important' }}
                                                    showUploadList={false}
                                                    action={`${CONSTANT.API.EXTRA.UPLOAD_AVATAR}`}
                                                    data={{ type: 'agency' }}
                                                    beforeUpload={beforeUploadAvatar("fCard")}
                                                    onChange={changeUploadAvatar("fCard")}
                                                    headers={{
                                                        'X-TK': CONSTANT.API.KEY
                                                    }}
                                                >
                                                    {identityCardFront ? <img src={CONSTANT.STATIC_URL + identityCardFront} alt="Mặt trước" style={{ width: '100%' }} /> :
                                                        <div>
                                                            {identityCardFront ? <LoadingOutlined /> : <PlusOutlined />}
                                                            <div style={{ marginTop: 8 }}>Mặt trước</div>
                                                        </div>}
                                                </Upload>

                                            </Col>
                                            <Col>
                                                <Upload
                                                    name="file"
                                                    listType="picture-card"
                                                    showUploadList={false}
                                                    action={`${CONSTANT.API.EXTRA.UPLOAD_AVATAR}`}
                                                    data={{ type: 'agency' }}
                                                    beforeUpload={beforeUploadAvatar("bCard")}
                                                    onChange={changeUploadAvatar("bCard")}
                                                    headers={{
                                                        'X-TK': CONSTANT.API.KEY
                                                    }}
                                                >
                                                    {identityCardBackside ? <img src={CONSTANT.STATIC_URL + identityCardBackside} alt="Mặt sau" style={{ width: '100%' }} /> :
                                                        <div>
                                                            {identityCardBackside ? <LoadingOutlined /> : <PlusOutlined />}
                                                            <div style={{ marginTop: 8 }}>Mặt sau</div>
                                                        </div>}
                                                </Upload>
                                            </Col>
                                        </Row>
                                    </Form.Item></>

                            }
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                            <Form.Item label="Mô tả ngắn về dịch vụ" name="summary"
                                rules={[
                                    {
                                        required: true, message: 'Vui lòng nhập mô tả ngắn về về dịch vụ của bạn!',
                                        type: 'string', max: 500, message: "Mô tả ngắn tối đa 500 ký tự !"
                                    }
                                ]}>
                                <TextArea showCount maxLength={500} />
                            </Form.Item>

                        </Col>
                        <Col xs={24} sm={24} md={24}>
                            <div className="ant-descriptions-title">Tài khoản ngân hàng</div>
                        </Col>
                        <Col xs={24} sm={12} md={8}>
                            <Form.Item label="Tên ngân hàng" name="bank_name"
                                rules={[
                                    {
                                        required: true, message: 'Vui lòng nhập tên ngân hàng!',
                                        type: 'string', max: 100, message: "Tên ngân hàng tối đa 100 ký tự !"
                                    }
                                ]}>
                                <Input placeholder="Nhập tên ngân hàng" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8}>
                            <Form.Item label="Tên chi nhánh ngân hàng" name="bank_branch_name"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập tên chi nhánh !' },
                                    {
                                        type: 'string', max: 100, message: "Tên chi nhánh tối đa 100 ký tự !"
                                    }
                                ]}>
                                <Input placeholder="Nhập tên chi nhánh" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8}>
                            <Form.Item label="Số tài khoản" name="account_number"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập số tài khoản !' },
                                    {
                                        type: 'string', max: 100, message: "Số tài khoản tối đa 100 ký tự !"
                                    }
                                ]}>
                                <Input placeholder="Nhập số tài khoản" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8}>
                            <Form.Item label="Họ và tên chủ tài khoản" name="account_full_name"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập họ và tên!' },
                                    {
                                        type: 'string', max: 64, message: "Họ và tên tối đa 64 ký tự !"
                                    }
                                ]}>
                                <Input placeholder="Nhập họ và tên" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8}>
                            <Form.Item label="Tên chủ tài khoản (Viết in hoa không dấu)" name="account_full_name_upper"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập tên chủ tài khoản !' },
                                    {
                                        type: 'string', max: 64, message: "Họ và tên tối đa 64 ký tự !"
                                    }
                                ]}>
                                <Input placeholder="Nhập tên in hoa không dấu - NGUYEN VAN A" />
                            </Form.Item>
                        </Col>
                        {/* <Col xs={24} sm={24} md={24}>
                            <div className="ant-descriptions-title">Trạng thái</div>
                        </Col>
                        <Col xs={24} sm={12} md={8}>
                            <Form.Item name="status">
                                <Select
                                    placeholder="Chọn trạng thái"
                                    style={{ width: '100%' }}>
                                    {
                                        status.map(item => <Select.Option key={item.value}>{item.label}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col> */}
                    </Row>

                    <div className="footer-toolbar">
                        <div className="right">
                            <Button type="primary" icon={<SaveOutlined />}
                                htmlType="submit"
                            >
                                Lưu thông tin
                            </Button>
                        </div>

                    </div>
                </Form>

            </Layout.Content>

        </div >
    )

}

export default InfoAgency;
